import { render } from "./tagBox.vue?vue&type=template&id=2a961ac3&ts=true"
import script from "./tagBox.ts?vue&type=script&lang=ts"
export * from "./tagBox.ts?vue&type=script&lang=ts"

import "./tagBox.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__